<script>
import appConfig from "@/app.config";
import NavBarAuth from '@/components/navbar-auth';
import FooterAuth from '@/components/footer-auth';

import {
  required,
  email,
} from "vuelidate/lib/validators";

/**
 * Forgot password component
 */
export default {
  name: "ForgotPassword",
  page: {
    title: "Forgot Password",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { NavBarAuth, FooterAuth },
  data() {
    return {
      form: {
        email: "",
      },
      isForgotError: false,
      errorMessage: null,
      isForgotSuccess: false,
      successMessage: null,
    };
  },
  validations: {
    form: {
      email: { required, email },
    }
  },
  methods: {
    tryToForgot() {
      // stop here if form is invalid
      this.$v.$touch();
      if (!this.$v.$invalid) {
        // hit api disini
        this.$axios.post('/v1/logistic_company/forgot_password', this.form)
          .then(response => {
            this.isForgotSuccess = true;
            this.isForgotError = false;
            this.successMessage = response.data.message;
            this.form.email = "";
            this.$v.$reset();
          }).catch(error => {
            this.isForgotError = true;
            this.isForgotSuccess = false;
            this.errorMessage = error.response.data.message;
          })
      }
    }
  }
};
</script>

<template>
  <div class="front-page account-pages my-5 pt-5">
    <NavBarAuth />
    <div class="front-bg"></div>
    <div class="container">
      <div class="row justify-content-center mt-5 mb-5">
        <div class="col-md-8 col-lg-6 col-xl-6">
          <div class="card overflow-hidden mt-5">
            <div class="text-semi-black text-center pt-5 pb-1">
              <img id="back" src="@/assets/images/arrow.png" alt @click="$router.push('/login')" />
              <h1>
                {{ $t('auth.forgot_password') | capitalize }}
              </h1>
            </div>
            <div class="card-body px-5 pt-0">
              <div class="p-3">
                <b-alert v-model="isForgotSuccess" class="mt-3" variant="success" dismissible>{{successMessage}}</b-alert>
                <b-alert v-model="isForgotError" class="mt-3" variant="danger" dismissible>{{errorMessage}}</b-alert>
                <p class="text-black-50 mb-0 mt-2 font-size-12">{{ $t('auth.forgot_password_desc') }}</p>
                <b-form @submit.prevent="tryToForgot" class="form-horizontal mt-4">
                  <b-form-group id="email-group" :label="$t('form.placeholder.enter_email')" label-for="email">
                    <b-form-input
                      id="email"
                      name=""
                      v-model="form.email"
                      :class="{ 'is-invalid': $v.form.email.$error }"
                      type="text"
                    ></b-form-input>
                    <div v-if="$v.form.email.$error" class="invalid-feedback">
                      <span v-if="!$v.form.email.required">{{ $t('form.validation.required', { field: 'Email' }) }}</span>
                      <span v-if="!$v.form.email.email">{{ $t('form.validation.email', { field: 'Email' }) }}</span>
                    </div>
                  </b-form-group>

                  <div class="form-group row mb-5 mt-5">
                    <div class="col-12">
                      <b-button type="submit" variant="danger" size="lg" class="w-100">{{ $t('form.button.submit') }}</b-button>
                    </div>
                  </div>
                </b-form>
              </div>
            </div>
            <!-- end card-body -->
          </div>
          <!-- end card -->
        </div>
        <!-- end col -->
      </div>
      <!-- end row -->
    </div>
    <FooterAuth />
  </div>
</template>

<style lang="css" scoped>
#back {
  width: 30px;
  position: absolute;
  font-weight: 900;
  font-size: 24px;
  left: 64px;
  top: 58px;
  cursor: pointer;
}
</style>